// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const bubbleStyles = () => {
    return css`
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        font-size: ${pxToRem(16)};
        width: 0.8em;
        height: 0.8em;
        padding: ${pxToRem(1)};
        font-weight: ${x => x.theme.design.typography.weight.bold};
        border: 1px solid ${getColor("header.accent")};
        background-color: ${getColor("header.accent")};
        color: ${getColor("header.accentContrast")};
        border-radius: 50%;
        letter-spacing: ${pxToRem(-0.5)};
    `;
};
